export const EventQuestionDestinationType = {
  BOOKING: 'BOOKING',
  CHECKOUT: 'CHECKOUT',
};

export const EventQuestionDestinationTypes = [
  EventQuestionDestinationType.BOOKING,
  EventQuestionDestinationType.CHECKOUT,
];
